import type { ParseConfig, ParseResult } from "papaparse";
import { readString } from "react-papaparse";

// react-papaparse's readString is Papa.parse, but it declares the worker
// variant, which takes a complete callback and returns void. It returns the
// result synchronously, as sagas/weighLots.js has always relied on.
export const parseCsv = readString as unknown as <T>(
  csvString: string,
  config?: ParseConfig<T>,
) => ParseResult<T>;
